/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         16/04/25
 * Module name:  users-module-permissions.const
 * File name:    users-module-permissions.const.ts
 * IDE:          WebStorm
 */


import {UserLevelEnum} from '@zibanu/auth';
import {CustomerLevelEnum} from '@shared/interface';

export interface ValidationParamsAdministration {
  userRole: UserLevelEnum;
  customerRole: CustomerLevelEnum[];
}

export interface CustomerAdministrationInterface {
  panel: ValidationParamsAdministration;
  administration: ValidationParamsAdministration;
  customersList: ValidationParamsAdministration;
  contractsList: ValidationParamsAdministration;
  usersList: ValidationParamsAdministration;
  groupsList: ValidationParamsAdministration;
  contactsList: ValidationParamsAdministration;
  locationsList: ValidationParamsAdministration;
  triggersList: ValidationParamsAdministration;
  customization: ValidationParamsAdministration;
}

export interface SystemAdministrationInterface {
  defaultParameters: ValidationParamsAdministration;
  defaultCommands: ValidationParamsAdministration;
  icons: ValidationParamsAdministration;
  sensors: ValidationParamsAdministration;
  deviceModel: ValidationParamsAdministration;
  devices: ValidationParamsAdministration;
}

const diamondPartners: CustomerLevelEnum[] = [CustomerLevelEnum.diamond];

const partnersLevelList: CustomerLevelEnum[] = [
  CustomerLevelEnum.silver,
  CustomerLevelEnum.gold,
  CustomerLevelEnum.platinum,
  CustomerLevelEnum.zafiro,
    ...diamondPartners
];

const customersLevelList: CustomerLevelEnum[] = [
  CustomerLevelEnum.final,
];

const customersValidations: CustomerAdministrationInterface = {
  panel: {
    userRole: UserLevelEnum.Operator,
    customerRole: [CustomerLevelEnum.final],
  },
  administration: {
    userRole: UserLevelEnum.Operator,
    customerRole: partnersLevelList,
  },
  customersList: {
    userRole: UserLevelEnum.Operator,
    customerRole: partnersLevelList,
  },
  contractsList: {
    userRole: UserLevelEnum.Operator,
    customerRole: [...customersLevelList, ...partnersLevelList],
  },
  usersList: {
    userRole: UserLevelEnum.Operator,
    customerRole: [...customersLevelList, ...partnersLevelList],
  },
  groupsList: {
    userRole: UserLevelEnum.Operator,
    customerRole: [CustomerLevelEnum.final],
  },
  contactsList: {
    userRole: UserLevelEnum.Operator,
    customerRole: [CustomerLevelEnum.final],
  },
  locationsList: {
    userRole: UserLevelEnum.Operator,
    customerRole: [CustomerLevelEnum.final],
  },
  triggersList: {
    userRole: UserLevelEnum.Operator,
    customerRole: [CustomerLevelEnum.final],
  },
  customization: {
    userRole: UserLevelEnum.Operator,
    customerRole: [CustomerLevelEnum.final],
  }
};

const systemValidations: SystemAdministrationInterface = {
  defaultParameters: {
    userRole: UserLevelEnum.Operator,
    customerRole: diamondPartners,
  },
  defaultCommands: {
    userRole: UserLevelEnum.Operator,
    customerRole: diamondPartners,
  },
  icons: {
    userRole: UserLevelEnum.Operator,
    customerRole: diamondPartners,
  },
  sensors: {
    userRole: UserLevelEnum.Operator,
    customerRole: diamondPartners,
  },
  deviceModel: {
    userRole: UserLevelEnum.Operator,
    customerRole: diamondPartners,
  },
  devices: {
    userRole: UserLevelEnum.Operator,
    customerRole: diamondPartners,
  },
};

export {
  customersValidations,
  systemValidations
};
